module.exports = __webpack_public_path__ + "img/kp.f08daf33.svg";